<div class="wrapper">
  <app-header></app-header>

  <main>
    <router-outlet></router-outlet>
  </main>

  <app-footer></app-footer>
  <app-back-to-top></app-back-to-top>
</div>
